import 'promise-polyfill/src/polyfill';
import 'svgxuse';
import ObjectFitImages from 'object-fit-images';

import ParallaxMove from './base/script/parallax';
import Header from './blocks/header/header';
import FirstScreen from './blocks/first-screen/first-screen';
import PersonalForm from './blocks/personalForm/personalForm';
import About from './blocks/about/about';
import Gallery from './blocks/gallery/gallery';
import Stock from './blocks/stock/stock';
import Partners from './blocks/partners/partners';
import Catalog from './blocks/catalog/catalog';
import Facing from './blocks/facing/facing';
import Location from './blocks/location/location';
import SectionObject from './blocks/sectionObject/sectionObject';
import FacingSection from './blocks/facing-section/facing-section';
import Map from './blocks/map/map';
import Projects from './blocks/projects/projects';
import Popup from './blocks/popup/popup';
import PopupCallback from './blocks/popup/callback/popup-callback';
import PopupOffer from './blocks/popup/offer/popup-offer';
import Calculator from './blocks/calculator/calculator';
import TopProjects from './blocks/topProjects/topProjects';
import FooterAccordion from './blocks/footer/accordion/footer-accordion';
import FacingSectionHorizontal from './blocks/facing-section/horizontal/facing-section-horizontal';
import GalleryPlate from './blocks/gallery/plate/gallery-plate';
import { animation } from './blocks/animations/animations';

import recaptcha from './base/script/recaptcha';
import Infrastructure from './blocks/infrastructure/infrastructure';
import Brief from './blocks/brief/brief';

require('custom-event-polyfill');
require('lazysizes');
require('./autoload.scss');

window.bodyLock = require('body-scroll-lock');

ObjectFitImages(null, { watchMQ: true });

window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.customMedia = {
  '--small': '(max-width: 767px)',
  '--medium': '(min-width: 768px) and (max-width: 1279px)',
  '--large': '(min-width: 1280px)',
};
window.lazySizesConfig.preloadAfterLoad = true;
window.lazySizesConfig.expand = 600;
window.lazySizesConfig.expFactor = 1;

window.debounce = (f, ms) => {
  let timer = null;

  return (...args) => {
    const onComplete = () => {
      f.apply(this, args);
      timer = null;
    };

    if (timer) {
      clearTimeout(timer);
    }

    timer = setTimeout(onComplete, ms);
  };
};

if (window.captchaSitekey) {
  recaptcha.setKey(window.captchaSitekey);
  window.recaptchaLoad = () => {
    recaptcha.load();
  };
}

window.intlTelInputGlobals.loadUtils('utils.js').then(() => {
  window.dispatchEvent(new window.CustomEvent('intlTelUtilsLoad'));
}).catch(error => new Error(error));


const mq = document.querySelector('[data-marquiz-id]');
if (mq) {
  const stringId = mq.getAttribute('data-marquiz-id');
  ((w, d, s, o) => {
    const j = d.createElement(s);
    j.async = true;
    j.src = '//script.marquiz.ru/v2.js';
    j.onload = () => {
      if (document.readyState !== 'loading') {
        window.Marquiz.init(o);
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          window.Marquiz.init(o);
        });
      }
    };
    d.head.insertBefore(j, d.head.firstElementChild);
  })(window, document, 'script', {
    host: '//quiz.marquiz.ru',
    region: 'eu',
    id: stringId,
    autoOpen: false,
    autoOpenFreq: 'once',
    openOnExit: false,
    disableOnMobile: false,
  });
  // eslint-disable-next-line
    (function(t, p) {window.Marquiz ? Marquiz.add([t, p]) : document.addEventListener('marquizLoaded', function() {Marquiz.add([t, p])})})('Inline', {id: stringId, buttonText: 'Пройти тест', bgColor: '#f00045', textColor: '#ffffff', rounded: true, shadow: 'rgba(240, 0, 69, 0.5)', blicked: true, buttonOnMobile: true});
}

Header();
FirstScreen();
PersonalForm();
About();
Stock();
Map();
Partners();
Catalog();
SectionObject();
TopProjects();
FacingSection();
PopupCallback();
Calculator();
PopupOffer();
FacingSectionHorizontal();
GalleryPlate();

window.closeMenu = (menu, wrp) => {
  window.bodyLock.enableBodyScroll(wrp);
  menu.classList.remove('header-menu--show');

  setTimeout(() => {
    menu.classList.remove('header-menu--open');
  }, 400);
};

new ParallaxMove();

const menu = document.querySelector('.header-menu');
[].slice.call(document.querySelectorAll('.header-menu__link')).forEach((btn) => {
  if (btn) {
    btn.addEventListener('click', () => {
      const menuWrp = menu.querySelector('.header-menu__wrp');
      if (menu.classList.contains('header-menu--open')) {
        window.closeMenu(menu, menuWrp);
      }
    });
  }
});

[].slice.call(document.querySelectorAll('.gallery')).forEach((galleryBlock) => {
  if (galleryBlock) {
    new Gallery(galleryBlock);
  }
});

[].slice.call(document.querySelectorAll('.location')).forEach((elem) => {
  if (elem) {
    new Location(elem);
  }
});

const callbackPopup = new Popup({
  popup: '#callback',
});

window.callbackPopup = new Popup({
  popup: '#callback',
  type: 'new',
});

const header = document.querySelector('.header');
const successPopup = document.querySelector('.popup-success');
const successCloseBtn = successPopup.querySelector('.popup-success__back-link');
window.successPopup = new Popup({
  overlay: successPopup,
  popup: '#popup-success',
});

window.openSuccessPopup = () => {
  window.successPopup.open();
  header.classList.add('header--white');
};

if (successCloseBtn) {
  successCloseBtn.addEventListener('click', (e) => {
    e.preventDefault();

    window.successPopup.close();
    if (header.getAttribute('data-keepwhite') !== 'true') {
      header.classList.remove('header--white');
    }
  });
}

[].slice.call(document.querySelectorAll('[data-popup]')).forEach((button) => {
  if (button) {
    button.addEventListener('click', (e) => {
      e.preventDefault();
      if (button.dataset.type && button.dataset.type === 'presentation') {
        const callbackPopupPresentation = new Popup({
          popup: '#callback',
          type: 'presentation',
        });
        callbackPopupPresentation.open();
      } else if (button.dataset.type && button.dataset.type === 'calculator') {
        const callbackPopupCalculator = new Popup({
          popup: '#callback',
          type: 'calculator',
        });
        callbackPopupCalculator.open();
      } else if (button.dataset.type && button.dataset.type === 'new') {
        const callbackPopupNew = new Popup({
          popup: '#callback',
          type: 'new',
        });
        window.LCDPopupData = {
          id: button.dataset.id,
          title: button.dataset.title,
        };
        callbackPopupNew.open();
      } else {
        callbackPopup.open();
      }
    });
  }
});

[].slice.call(document.querySelectorAll('.facing')).forEach((el) => {
  if (el) {
    new Facing(el);
  }
});

[].slice.call(document.querySelectorAll('.projects')).forEach((el) => {
  if (el) {
    new Projects(el);
  }
});

[].slice.call(document.querySelectorAll('.footer-accordion')).forEach((el) => {
  if (el) {
    new FooterAccordion(el);
  }
});

[].slice.call(document.querySelectorAll('.infrastructure')).forEach((el) => {
  if (el) {
    new Infrastructure(el);
  }
});

[].slice.call(document.querySelectorAll('.brief')).forEach((el) => {
  if (el) {
    new Brief(el);
  }
});

animation();



// WEBPACK FOOTER //
// ./autoload.js